export enum AppRoute {
  Base = '',
  Auth = 'auth',
  ComponentList = 'component-list',
  Report = 'ZonescanNet/Report',
}
